
import { useForm } from 'react-hook-form';
import styles from './signUpForm.module.css';
import { Button } from '../../ui/button/Button';
import { useMutation } from '@tanstack/react-query';
import { authApi } from '../../../api/authMutation/authApi';
import { useUserStore } from '../../../stores/useUserStore';
export function SignUpForm() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm();
  const { setCredentials } = useUserStore();
  const { mutate, error } = useMutation({


    mutationFn: (loginData) => {
      return authApi.signUp(loginData);
    },
    onSuccess: (data) => {
      setCredentials(data.data.username)
    }
  });



  const onSubmit = (data) => {
    console.log(data);

    mutate(data);
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
      <div className={styles.formHeader}>Регистрация</div>
      <div className={styles.formGroup}>
        <div>
          <div className={styles.input_wrapper}>
            <input
              placeholder="Имя"
              className={`${styles.input} ${errors.username && styles.errorInput}`}
              {...register('username', { required: 'Это поле обязательно' })}
            />
            {(errors.username || error) && (
              <span className={styles.error}>
                {errors.username?.message || error?.message || "Непредвиденная ошибка"}
              </span>
            )}
          </div>
        </div>

        <div>
          <input
            className={`${styles.input} ${errors.email && styles.errorInput}`}
            placeholder="Эл. почта"
            {...register('email', {
              required: 'Это поле обязательно',
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: 'Неверный формат email',
              },
            })}
            type="email"
          />
          {(errors.email || error) && (
            <span className={styles.error}>
              {errors.email?.message || error?.message || "Непредвиденная ошибка"}
            </span>
          )}
        </div>
        <div>
          <input
            className={`${styles.input} ${errors.password && styles.errorInput}`}
            placeholder="Пароль"
            {...register('password', {
              required: 'Это поле обязательно',
              minLength: { value: 8, message: 'Пароль должен быть не менее 8 символов' },
            })}
            type="password"
          />
          {(errors.password || error) && (
            <span className={styles.error}>
              {errors.password?.message || error?.message || "Непредвиденная ошибка"}
            </span>
          )}
        </div>
        <div>
          <input
            className={`${styles.input} ${errors.password_confirm && styles.errorInput}`}
            placeholder="Повторите пароль"
            {...register('password_confirm', {
              required: 'Это поле обязательно',
              validate: (val) => {
                if (watch('password') !== val) {
                  return 'Пароли не совпадают';
                }
              },
            })}
            type="password"
          />
          {(errors.password_confirm || error) && (
            <span className={styles.error}>
              {errors.password_confirm?.message || error?.message || "Непредвиденная ошибка"}
            </span>
          )}
        </div>
      </div>
      <Button type="submit" variant={'dark-blue'}>
        Зарегистрироваться
      </Button>
    </form>
  );
}
